<template>
    <div
        class="relative flex items-center transition-all duration-300 backdrop:blur-xl before:absolute before:left-0 before:top-1/2 before:z-20 before:block before:h-full before:w-full before:-translate-y-1/2 before:scale-0 before:bg-white/50 before:opacity-0 before:shadow-sm before:blur-[3rem] before:transition-all before:duration-300 hover:scale-110 hover:before:scale-50 hover:before:opacity-20">
        <slot />
    </div>
</template>

<script setup lang="ts"></script>
